<template>
  <transition name="modal">
    <div class="text-left modal-mask">
      <div class="modal-wrapper" @click="layerClick" id="modalCheck">
        <div class="modal-container">
          <div class="modal-header">
            <h4>გაგვიზიარეთ თქვენი აზრი</h4>
          </div>

          <div class="modal-body" v-if="!showForm">მადლობას გიხდით თქვენი კომენტარი მიღებულია</div>

          <div class="modal-body" v-else>
            <div class="form-group">
              <label for>სათაური</label>
              <input type="text" class="form-control" v-model="feedback.title" />
            </div>
            <div class="form-group">
              <label for>აღწერა</label>
              <textarea
                type="text"
                class="form-control"
                style="height: 200px"
                v-model="feedback.body"
              ></textarea>
            </div>
            <div class="form-group">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  value="1"
                  v-model="feedback.show_author"
                  id="wishCheck"
                />
                <label class="custom-control-label" for="wishCheck">გამოჩდეს ჩემი სახელი</label>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              class="btn btn-sm btn-success"
              :class="{regsending: sending}"
              v-if="showForm"
              @click="store"
            >გაგზავნა</button>
            <button class="btn btn-sm btn-success" v-else @click="showForm = true">თავიდან გაგზავნა</button>

            <button class="btn btn-sm btn-danger" @click="closeModal">დახურვა</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      feedback: {
        title: "",
        body: "",
        show_author: true
      },
      showForm: true,
      sending: false
    };
  },
  methods: {
    closeModal() {
      this.$emit("closemodal");
    },
    layerClick(e) {
      if (e.target.id == "modalCheck") this.closeModal();
    },
    store() {
      if (
        this.feedback.title.trim().length == 0 ||
        this.feedback.body.trim().length == 0
      ) {
        return alert("გთხოვთ შეავსოთ მოცემული ველი");
      }
      this.sending = true;
      axios
        .post("/feedback", this.feedback)
        .then(res => {
          this.showForm = false;
          this.feedback = { title: "", body: "" };
          this.sending = false;
        })
        .catch(errors => console.log(errors));
    }
  }
};
</script>

